$(function() {
    let $loadBrokersContent = $('#loadBrokersContent');
    let params = (new URL(document.location)).searchParams;
    let code = params.get('code');
    if($loadBrokersContent.length && code !== null) {
        localStorage.setItem('preloader', 'false');
        setTimeout(function () {
            $.ajax({
                url: window.ajax_url,
                data: {
                    'action': 'get_brokers_by_code',
                    'data': {
                        code: code,
                    },
                },
                type: 'POST',
            }).done(function (res) {
                let response = JSON.parse(res);
                window.post_code = response.post_code;
                window.offset = parseInt(response.offset);
                $('#countBroker').text(response.found_posts);
                $('#postCode').text(post_code);
                if (response.html !== '') {
                    $loadBrokersContent.html(response.html);
                    $loadBrokersContent.find('.broker-card').fadeIn(300);
                }
                if(response.found_posts === $loadBrokersContent.children('.broker-card').length) {
                    $('#showMoreBrokers').remove();
                }
            }).fail(function () {
                alert('Error query');
            });
        }, 300);
    }

    jQuery(document).on('click', '.contact-broker', function (e) {
        e.preventDefault();
        let params = (new URL(document.location)).searchParams;
        let post_code = params.get('post_code');
        let broker_id = $(this).data('id');
        let $successContactModal = $('#successContactModal');
        $.ajax({
            url: window.ajax_url,
            data: {
                'action': 'contact_to_broker',
                'broker_id': broker_id,
                'post_code': post_code,
            },
            type: 'POST',
        }).done(function (res) {
            let response = JSON.parse(res);
            $successContactModal.find('#brokerName').text(response.broker_name);
            $successContactModal.modal('show');
        }).fail(function (error) {
            alert(error);
        });
    });
    
    var slideIndex = 1;

    $(document).on('click', '.gallery-item', function (e) {
        var gallery_item = $(this).closest('.gallery-list').find('.gallery-item img');
        $('.slides-list').html('');
        $('.bullets-list').html('');
        $(gallery_item).each(function(index, value){
            var src = $(this).attr('src');
            $('.slides-list').append('<img class="single_slide" src="'+src+'"/>');
            $('.bullets-list').append('<span class="bullet" number="'+(index + 1)+'"></span>');
        });
        slideIndex = parseInt($(this).attr('number')) + 1;
        showSlides(slideIndex);
        $('.gallery-lightbox').show();
    });

    $(document).on('click', '.close-gallery', function (e) {
        $('.gallery-lightbox').hide();
    });

    $(document).on('click', '.bullet', function (e) {
        var slide_number = $(this).attr('number');
        showSlides(slideIndex = slide_number);
    });

    $(document).on('click', '.gallery-lightbox .prev', function (e) {
        showSlides(slideIndex -= 1);
    });

    $(document).on('click', '.gallery-lightbox .next', function (e) {
        showSlides(slideIndex += 1);
    });

    function showSlides(n) {
        var i;
        var slides = document.getElementsByClassName("single_slide");
        var dots = document.getElementsByClassName("bullet");
        if (n > slides.length) {slideIndex = 1}
        if (n < 1) {slideIndex = slides.length}
        for (i = 0; i < slides.length; i++) {
            slides[i].style.display = "none";
        }
        for (i = 0; i < dots.length; i++) {
            dots[i].className = dots[i].className.replace(" active", "");
        }
        slides[slideIndex-1].style.display = "block";
        dots[slideIndex-1].className += " active";
    }

    let xPos;
    const touchStart = (event) => {
    xPos = event.pageX;
    };
    const touchEnd = (event) => {
        if (event.pageX < xPos) {
            showSlides(slideIndex -= 1);
        } else {
            showSlides(slideIndex += 1);
        }
    };

    $(document).on('touchstart', '.single_slide', touchStart);
    $(document).on('touchend', '.single_slide', touchEnd);
});



// WEBPACK FOOTER //
// ./scripts/routes/brokers.js